(function () {
  function isVisible(el) {
    return !!(el && el.offsetParent !== null);
  }

  function canAutoPlay(component, slider) {
    if (!slider || slider.dataset.autoplay !== 'true') return false;
    if (component.sliderAutoplayButton) return !!component.autoplayButtonIsSetToPlay;
    return true;
  }

  function SlideshowVideoController(component) {
    this.component = component;
    this.slider = component.querySelector('[id^="Slider-"]');
    if (!this.slider) return;

    this.endAction = this.slider.dataset.videoEndAction || 'next_slide';
    this.videos = Array.prototype.slice.call(this.slider.querySelectorAll('.slideshow__video-player'));
    if (!this.videos.length) return;

    this.sync = this.sync.bind(this);
    this.onVideoEnded = this.onVideoEnded.bind(this);

    this.videos.forEach(function (video) {
      video.muted = true;
      video.playsInline = true;
      video.preload = 'none';
      video.setAttribute('playsinline', 'playsinline');
      video.addEventListener('ended', this.onVideoEnded);
    }, this);

    this.component.addEventListener('slideChanged', this.sync);
    this.slider.addEventListener(
      'scroll',
      function () {
        clearTimeout(this._syncTimer);
        this._syncTimer = setTimeout(this.sync, 90);
      }.bind(this),
      { passive: true }
    );

    if (this.component.prevButton) {
      this.component.prevButton.addEventListener('click', function () {
        requestAnimationFrame(this.sync);
      }.bind(this));
    }

    if (this.component.nextButton) {
      this.component.nextButton.addEventListener('click', function () {
        requestAnimationFrame(this.sync);
      }.bind(this));
    }

    document.addEventListener(
      'visibilitychange',
      function () {
        if (document.hidden) {
          this.pauseAllVideos();
        } else {
          this.sync();
        }
      }.bind(this)
    );

    this.sync();
  }

  SlideshowVideoController.prototype.getActiveSlide = function () {
    return this.slider.querySelector('.slideshow__slide[aria-hidden="false"]') || this.slider.querySelector('.slideshow__slide');
  };

  SlideshowVideoController.prototype.getActiveVideo = function (slide) {
    if (!slide) return null;
    var candidates = Array.prototype.slice.call(slide.querySelectorAll('.slideshow__video-player'));
    if (!candidates.length) return null;
    for (var i = 0; i < candidates.length; i += 1) {
      if (isVisible(candidates[i])) return candidates[i];
    }
    return candidates[0];
  };

  SlideshowVideoController.prototype.pauseAllVideos = function (exceptVideo) {
    this.videos.forEach(function (video) {
      if (video !== exceptVideo && !video.paused) {
        video.pause();
      }
    });
  };

  SlideshowVideoController.prototype.ensureVideoLoaded = function (video) {
    if (!video || video.dataset.lazyLoaded === 'true') return;

    var sourceNodes = Array.prototype.slice.call(video.querySelectorAll('source[data-src]'));
    if (sourceNodes.length) {
      sourceNodes.forEach(function (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
      });
    } else if (video.dataset.src) {
      video.src = video.dataset.src;
      video.removeAttribute('data-src');
    }

    video.dataset.lazyLoaded = 'true';
    video.load();
  };

  SlideshowVideoController.prototype.playVideo = function (video) {
    if (!video) return;

    this.ensureVideoLoaded(video);

    if (video.readyState < 2) {
      video.addEventListener(
        'loadeddata',
        function () {
          var retry = video.play();
          if (retry && typeof retry.catch === 'function') {
            retry.catch(function () {});
          }
        },
        { once: true }
      );
    }

    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {});
    }
  };

  SlideshowVideoController.prototype.resumeSliderAutoplay = function () {
    if (typeof this.component.play === 'function' && canAutoPlay(this.component, this.slider)) {
      this.component.play();
    }
  };

  SlideshowVideoController.prototype.pauseSliderAutoplay = function () {
    if (typeof this.component.pause === 'function') {
      this.component.pause();
    }
  };

  SlideshowVideoController.prototype.sync = function () {
    var activeSlide = this.getActiveSlide();
    var activeVideo = this.getActiveVideo(activeSlide);

    this.pauseAllVideos(activeVideo);

    if (!activeVideo) {
      this.resumeSliderAutoplay();
      return;
    }

    this.pauseSliderAutoplay();

    if (activeVideo.currentTime > 0 && !activeVideo.ended && !activeVideo.paused) {
      return;
    }

    activeVideo.currentTime = 0;
    this.playVideo(activeVideo);
  };

  SlideshowVideoController.prototype.goToNextSlide = function () {
    if (this.component.nextButton) {
      this.component.nextButton.click();
      return;
    }

    var step = this.component.sliderItemOffset || this.slider.clientWidth;
    var isLastSlide = this.component.currentPage === this.component.totalPages;
    var nextPosition = isLastSlide ? 0 : this.slider.scrollLeft + step;
    this.slider.scrollTo({ left: nextPosition });
  };

  SlideshowVideoController.prototype.onVideoEnded = function (event) {
    var endedVideo = event.currentTarget;
    var activeSlide = this.getActiveSlide();
    if (!activeSlide || !activeSlide.contains(endedVideo)) return;

    if (this.endAction === 'replay_video' || this.component.totalPages <= 1) {
      endedVideo.currentTime = 0;
      this.playVideo(endedVideo);
      return;
    }

    this.goToNextSlide();
    setTimeout(this.sync, 120);
  };

  function initSlideshowVideoControllers() {
    var components = document.querySelectorAll('slideshow-component[data-has-video-slides="true"]');
    components.forEach(function (component) {
      if (component.__slideshowVideoController) return;
      component.__slideshowVideoController = new SlideshowVideoController(component);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSlideshowVideoControllers);
  } else {
    initSlideshowVideoControllers();
  }

  document.addEventListener('shopify:section:load', initSlideshowVideoControllers);
})();
